<template>
  <div>
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="5">
        <div class="promo-title">Edit Products</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button v-if="product.data" size="small" type="primary" @click="save">Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row v-loading="product.isLoading" justify="center" align="middle"></el-row>
    <div v-if="!product.isLoading">
      <el-row
        type="flex"
        justify="center"
        align="middle"
        style="height: 50vh"
        v-if="Object.keys(product.data).length === 0"
      >
        <h1>Product Not Found</h1>
      </el-row>
      <el-row v-else class="mt-4">
        <el-form label-position="top" ref="product" label-width="120px" :model="product.data">
          <FormProduct :Product="product.data"></FormProduct>
        </el-form>
      </el-row>
    </div>
  </div>
</template>

<script>
import FormProduct from "./Product/Form";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    FormProduct
  },
  name: 'product-edit',
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapState({
      product: state => state.product.product
    })
  },
  methods: {
    ...mapActions({
      GetProductQuery: "product/GetProductQuery",
      updateProduct: "product/UpdateProduct"
    }),
    save() {
      this.$refs.product.validate(valid => {
        const body = {
          oracleItemId: this.product.data.oracleItemId,
          itemCode: this.product.data.itemCode,
          barcode: this.product.data.barcode,
          oracleItemCode: this.product.data.oracleItemCode,
          itemName: this.product.data.itemName,
          description: this.product.data.description,
          itemType: this.product.data.itemType,
          kategoriId: this.product.data.kategoriId,
          brandId: this.product.data.brandId,
          principal: this.product.data.principal,
          defaultUomCode: this.product.data.defaultUomCode,
          picture: this.product.data.picture,
          thumbnail: this.product.data.thumbnail,
          checkStock: this.product.data.checkStock
        };
        if (valid) {
          this.updateProduct(body);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    let option = {
        id: this.id,
        params: {
          page: 1,
          limit: 100,
        }
      };
    this.GetProductQuery(option);
  }
};
</script>

<style>
</style>
